import type { Cable, System, SystemNode } from "./types";

export function findNode(system: System, id: string): SystemNode | undefined {
  return system.nodes.find((n) => n.id === id);
}

export function findCable(system: System, id: string): Cable | undefined {
  return system.cables.find((c) => c.id === id);
}

/** Directly connecting cables, either direction — not a run that hops a junction. */
export function findCablesBetween(
  system: System,
  nodeA: string,
  nodeB: string,
): Cable[] {
  return system.cables.filter(
    (c) =>
      (c.fromNodeId === nodeA && c.toNodeId === nodeB) ||
      (c.fromNodeId === nodeB && c.toNodeId === nodeA),
  );
}
